"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UninformedErrorDTO = exports.ErrorDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let ErrorDTO = class ErrorDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsIn)(Object.values(types_1.GalEvents).filter((v) => v !== types_1.GalEvents.ErrorDTO)),
    (0, class_validator_1.IsDefined)(),
    (0, decorators_1.SnakeSansDTO)(),
    (0, decorators_1.Describe)("GalEvent Enum type of event which would have replaced this failure, in async cases, this would be the 'complete'"),
    (0, decorators_1.Warning)('Failing event type should be sent prior to error if possible'),
    (0, decorators_1.Example)('GalEvents'),
    __metadata("design:type", Object)
], ErrorDTO.prototype, "failedType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, decorators_1.Describe)('Application-specific error code'),
    __metadata("design:type", String)
], ErrorDTO.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Custom error message'),
    __metadata("design:type", String)
], ErrorDTO.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional context regarding this failure'),
    __metadata("design:type", Object)
], ErrorDTO.prototype, "context", void 0);
ErrorDTO = __decorate([
    (0, decorators_1.Describe)('An error occured in a previous event'),
    (0, decorators_1.Warning)('DTO event matching failedType should be context of failed event')
], ErrorDTO);
exports.ErrorDTO = ErrorDTO;
let UninformedErrorDTO = class UninformedErrorDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, decorators_1.Describe)('Application-specific error code'),
    __metadata("design:type", String)
], UninformedErrorDTO.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Custom error message'),
    __metadata("design:type", String)
], UninformedErrorDTO.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional context regarding this failure'),
    __metadata("design:type", Object)
], UninformedErrorDTO.prototype, "context", void 0);
UninformedErrorDTO = __decorate([
    (0, decorators_1.Describe)('An error occurred without a matching "try" event but should be reported'),
    (0, decorators_1.Warning)('Prefer ErrorDTO in all applicable cases')
], UninformedErrorDTO);
exports.UninformedErrorDTO = UninformedErrorDTO;
